import React from 'react';
import { Eye, Edit, Trash2, User, Calendar, Tag, DollarSign } from 'lucide-react';

const ProduitServiceCard = ({ produit, onView, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusBadge = () => {
    if (produit.is_active) {
      return (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          Actif
        </span>
      );
    }
    return (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
        Inactif
      </span>
    );
  };

  return (
    <div className="bg-white rounded-lg shadow hover:shadow-lg transition-shadow duration-200">
      {/* Image de couverture */}
      {produit.cover_image_url && (
        <div className="h-48 overflow-hidden rounded-t-lg">
          <img
            src={produit.cover_image_url}
            alt={produit.name}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-6">
        {/* En-tête avec statut */}
        <div className="flex items-start justify-between mb-3">
          <h3 className="text-lg font-semibold text-gray-900 flex-1">
            {produit.name}
          </h3>
          {getStatusBadge()}
        </div>

        {/* Description */}
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {produit.description}
        </p>

        {/* Catégorie et Prix */}
        <div className="space-y-2 mb-4">
          {produit.categorie && (
            <div className="flex items-center gap-2 text-sm text-gray-600">
              <Tag className="w-4 h-4 text-[#FF6B00]" />
              <span>{produit.categorie}</span>
            </div>
          )}
          
          <div className="flex items-center gap-2">
            <DollarSign className="w-4 h-4 text-[#437011]" />
            <span className="text-xl font-bold text-[#437011]">
              {Math.round(produit.price).toLocaleString('fr-FR')} FCFA
            </span>
          </div>
        </div>

        {/* Vendeur */}
        <div className="flex items-center gap-2 text-sm text-gray-600 mb-2">
          <User className="w-4 h-4 text-gray-400" />
          <span>
            {produit.user?.first_name} {produit.user?.last_name} (@{produit.user?.username})
          </span>
        </div>

        {/* Date de création */}
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
          <Calendar className="w-4 h-4" />
          <span>{formatDate(produit.created_at)}</span>
        </div>

        {/* Actions */}
        <div className="flex gap-2 pt-4 border-t">
          <button
            onClick={() => onView(produit)}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors"
          >
            <Eye className="w-4 h-4" />
            Voir
          </button>
          <button
            onClick={() => onEdit(produit)}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-[#FFF5ED] text-[#FF6B00] rounded-lg hover:bg-orange-100 transition-colors"
          >
            <Edit className="w-4 h-4" />
            Modifier
          </button>
          <button
            onClick={() => onDelete(produit.id)}
            className="flex items-center justify-center gap-2 px-4 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProduitServiceCard;
